(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["oum-vacation-popup"] && !Shopify.designMode) return;
  try {
    (() => {
    const popup = document.getElementById('OUMVacationPopup');
    if (!popup || popup.dataset.initialized === 'true') return;

    popup.dataset.initialized = 'true';

    const dialog = popup.querySelector('[data-oum-vacation-dialog]');
    const closeButtons = [...popup.querySelectorAll('[data-oum-vacation-close]')];
    const storageKey = 'oumVacationPopupDismissedAtV1';
    const startAt = new Date(popup.dataset.startAt).getTime();
    const endAt = new Date(popup.dataset.endAt).getTime();
    const dismissDuration = Number(popup.dataset.dismissDuration) || 3600000;
    const params = new URLSearchParams(window.location.search);
    const previewMode =
      document.documentElement.classList.contains('shopify-design-mode') ||
      params.has('preview_theme_id') ||
      window.location.hash === '#oum-vacation-preview';
    let reopenTimer;
    let previouslyFocused;

    const readDismissedAt = () => {
      try {
        return Number(window.localStorage.getItem(storageKey)) || 0;
      } catch (error) {
        return 0;
      }
    };

    const rememberDismissal = () => {
      try {
        window.localStorage.setItem(storageKey, String(Date.now()));
      } catch (error) {
        // The notice still closes if storage is unavailable.
      }
    };

    const isActive = () => {
      const now = Date.now();
      return previewMode || (now >= startAt && now < endAt);
    };

    const openPopup = () => {
      if (!isActive()) return;

      previouslyFocused = document.activeElement;
      popup.hidden = false;
      popup.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('oum-vacation-popup-is-open');
      window.requestAnimationFrame(() => closeButtons[0]?.focus());
    };

    const scheduleOpen = (delay) => {
      window.clearTimeout(reopenTimer);
      reopenTimer = window.setTimeout(openPopup, Math.max(0, delay));
    };

    const closePopup = () => {
      rememberDismissal();
      popup.hidden = true;
      popup.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('oum-vacation-popup-is-open');

      if (previouslyFocused instanceof HTMLElement) previouslyFocused.focus();
      if (previewMode || Date.now() + dismissDuration < endAt) scheduleOpen(dismissDuration);
    };

    closeButtons.forEach((button) => button.addEventListener('click', closePopup));

    dialog?.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        closePopup();
        return;
      }

      if (event.key !== 'Tab') return;

      const focusable = closeButtons.filter((button) => !button.disabled);
      if (focusable.length < 2) return;

      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    const now = Date.now();
    if (!previewMode && now < startAt) {
      scheduleOpen(startAt - now);
      return;
    }

    if (!isActive()) return;

    const remaining = dismissDuration - (now - readDismissedAt());
    if (!previewMode && remaining > 0) {
      scheduleOpen(remaining);
    } else {
      openPopup();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
